import { IssueTypeEnum } from '../types';
/**
 * Returns the translation key for an issue's display type label.
 *
 * For most issue types this is just `issue.issueType` (the raw enum string).
 * For `ulc_reference_clause_check`, the key varies by the `violation` field
 * in `issueData`:
 *   - 'incorrect_clause' → 'incorrect_code_reference'
 *   - anything else      → 'missing_code_reference'
 *
 * The returned key is looked up in the `issues_grid.issue_type_labels` namespace.
 */
export function getIssueTypeDisplayKey(issue) {
    var _a;
    if (issue.issueType === IssueTypeEnum.UlcReferenceClauseCheck) {
        const violation = (_a = issue.issueData) === null || _a === void 0 ? void 0 : _a.violation;
        return violation === 'incorrect_clause' ? 'incorrect_code_reference' : 'missing_code_reference';
    }
    return issue.issueType;
}
